import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Icon, Upload } from 'antd';
import { Text4 } from '../../../../styles';
import { alertify, size_greater_than, handleApiExceptions } from '../../../../app_methods';
import { MerchantBankAccount } from '../../../../models';
import './index.scss';

const bankAccount = new MerchantBankAccount();
let BankAccountFormComp = (props) => {
    const { form, account } = props;
    const { getFieldDecorator } = form;
    
    const validations = MerchantBankAccount.validations;
    const [validatingIFSC,setvalidatingIFSC] =useState(false)
    const [urls, setUrls] = useState({
        cancelled_cheque: "",
        other_document: ""
    });
    const isValidFile = (file) =>{
        if(typeof file == 'undefined') return true;
        if(typeof file == 'string') return true;
        let ext = file["file"]['type'].split('/')
        return file &&  (ext.includes('image') || ext.includes('pdf')) ;
    }
    const onSubmit = () => {

        form.validateFields((err, values) => {
            if (err) return;
            if (!values.cancelled_cheque) return;
            if(!isValidFile(values.cancelled_cheque) || !isValidFile(values.other_document) ){
                alertify("Failure", "Please select valid image or PDF file", "error");
                return;
            }
            
            if (values.cancelled_cheque.file instanceof File && size_greater_than(values.cancelled_cheque.file, 1000000)){
                alertify("Failure", "Cancelled Cheque File size cannot exceed 1 MB", "error");
                return
            }
            if (values.other_document && values.other_document.file instanceof File && size_greater_than(values.other_document.file, 1000000)){
                alertify("Failure", "Other Documents File size cannot exceed 1 MB", "error");
                return
            }
            props.onSubmit(values);
        });
    };

    // validate_ifsc
    const validate_ifsc = async() =>{
        if (form.getFieldValue('account_ifsc').length == 11){
            setvalidatingIFSC(true)
            const response = await bankAccount.validate_ifsc({ account_ifsc: form.getFieldValue('account_ifsc')});
            if (!response.success) {
                handleApiExceptions(response);
                return;
            }
            if (!response.data.success){
                alertify("Failure", response.data.message, "error");
            }
            form.setFieldsValue({ ...form.getFieldsValue(), "bank_name": response.data.bank, "bank_branch": response.data.branch });
            setvalidatingIFSC(false)
        }
    }

    // get signed url from S3
    const get_sugned_url = async(key) => {
        const response = await bankAccount.get_kyc_url({ document_key: key, account_uuid:account["id"]});
        return response;
    }

    const setDocUrls = () => {
        let _urls = { ...urls };
        if (account["cancelled_cheque"]) {
            let result_dict = {url:'', is_pdf:account['cancelled_cheque'].split('.').includes('pdf')};
            if (!result_dict.is_pdf){
                get_sugned_url("cancelled_cheque").then((response) => {
                    if (!response.success) {
                        handleApiExceptions(response);
                        return;
                    }
                    result_dict['url']= response.data.url
                    _urls["cancelled_cheque"] = result_dict
                    setUrls({..._urls});
                })
            }
            _urls["cancelled_cheque"] = result_dict
        };
        if (account["other_document"]) {
            let result_dict = {url:'', is_pdf:account['other_document'].split('.').includes('pdf')};
            if (!result_dict.is_pdf){
                get_sugned_url("other_document").then((response) => {
                    if (!response.success) {
                        handleApiExceptions(response);
                        return;
                    }
                    result_dict['url']= response.data.url
                    _urls["other_document"] = result_dict
                    setUrls({..._urls});
                })
            }
            _urls["other_document"] = result_dict
        };
        setUrls(_urls);
        
    }

    const download_file = async(key) => {
        get_sugned_url(key).then((response) => window.open(response.data.url, "_blank"))
    }


    const renderUploadInput = (label, key) => {
        const file = props.form.getFieldValue(key) || null;
        return (
            <Form.Item label={label == 'Cancelled Cheque'? <>{label} {account[key] ? <Icon type="check-circle" theme="twoTone" twoToneColor="green" style={{ marginTop: 6 }}/> : null}</>:'Other Document'}>
                    {getFieldDecorator(key, {
                        valuePropName: "file",
                        initialValue:account[key],
                        rules: props.account.is_edit ? [] : validations[key]
                    })(
                        <Upload.Dragger
                            name={key}
                            multiple={false}
                            showUploadList={false}
                            className="pl-0 d-block"
                            beforeUpload={(file) => {
                                return false;
                            }}
                            accept="image/*,.pdf"
                        >
                            {
                                account[key] ?
                                    <div>
                                        
                                        {urls[key].is_pdf?
                                            <Button icon="file" type="link" onClick={(e) => {e.stopPropagation();download_file(key)}}>
                                                Download file
                                            </Button>  
                                            : <>{!!urls[key].url && <img className="w-50 h-50" src={urls[key].url} />}</>
                                        }
                                    </div>
                                    :
                                    <p className="ant-upload-drag-icon"><Icon type="inbox" /></p>
                            }
                            {
                                file && typeof(file) != 'string' ? (
                                    <div className="mt-2 pl-1 file-name-elipses">
                                        <Text4 strong>Selected File:</Text4>
                                        <Text4 className="ml-2">
                                            {(file || {}).fileList[(file || {}).fileList.length - 1].name}
                                        </Text4>
                                    </div>
                                ) : <div className="mt-2">
                                        <Text4 className="d-block">Click or drag file to this area to upload</Text4>
                                    </div>
                            }
                        </Upload.Dragger>
                    )}
                </Form.Item>
        )
    }

    useEffect(() => {
        setDocUrls();
    }, [props.merchant]);

    return (
        <Form>
            {getFieldDecorator("id", {
                initialValue: account.id,
                rules: validations.id
            })(<Input hidden autoComplete='off'/>)}
            
            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Account Number">
                        {getFieldDecorator("account_number", {
                            initialValue: account.account_number,
                            rules: validations.account_number
                        })(<Input prefix={<Icon type="bank" />} autoComplete='off'/>)}
                    </Form.Item>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Account IFSC" onChange={validate_ifsc}>
                        {getFieldDecorator("account_ifsc", {
                            initialValue: account.account_ifsc,
                            rules: validations.account_ifsc
                        })(<Input prefix={<Icon type="bank" />} onChange={(e) => e.target.value = ("" + e.target.value).toUpperCase()} autoComplete='off'/>)}
                    </Form.Item>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Bank Branch" >
                        {getFieldDecorator("bank_branch", {
                            initialValue: account.bank_branch,
                            rules: validations.bank_branch,
                        })(<Input prefix={<Icon type="bank" />}  addonAfter={validatingIFSC? <Icon type="loading" spin={validatingIFSC} /> :null} disabled={validatingIFSC} autoComplete='off'/>)}
                    </Form.Item>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Bank Name" >
                        {getFieldDecorator("bank_name", {
                            initialValue: account.bank_name,
                            rules: validations.bank_name,
                        })(<Input prefix={<Icon type="bank" />}  addonAfter={validatingIFSC? <Icon type="loading" spin={validatingIFSC} /> :null} disabled={validatingIFSC} autoComplete='off'/>)}
                    </Form.Item>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Name On Bank">
                        {getFieldDecorator("name_on_bank", {
                            initialValue: account.name_on_bank,
                            rules: validations.name_on_bank
                        })(<Input prefix={<Icon type="user" />} autoComplete='off'/>)}
                    </Form.Item>
                </div>
            </div>
            <div className="row">
                <div className="col-sm mb-4 doc" >
                    {renderUploadInput("Cancelled Cheque", "cancelled_cheque")}
                </div>
                <div className="col-sm mb-4 doc" >
                    {renderUploadInput("Other Document", "other_document")}
                </div>
            </div>
            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" loading={props.loading} onClick={() => onSubmit()}>{props.account.is_edit ? "Update" : "Submit"}</Button>
            </div>
        </Form>
    )
};

const BankAccountForm = Form.create()(BankAccountFormComp);
export { BankAccountForm };